import { IMap } from './common'
import { IServiceObject } from './service'
import { IPromotion } from './promotions'
import { IOrgSubscriptionResponseDTO } from './subscriptions'

export const LOCAL_STORAGE_CURRENT_ORGANIZATION_KEY = 'currentOrganizationId'

export interface IOrgObj {
  id: string
  name: string
  logo: string
  email: string
  sendEmail: number
  state: string
  phone: string
  timeZone: number //TODO Fixed me
  timeFormat: string
  serviceAreaBounds?: string[]
  serviceAreaName?: string
  website: string
  role: string
  unlimited?: boolean
  description?: string
  services?: string[]
  bankAccounts?: string[]
  legalEntity?: any
  promotions?: IPromotion[]
  subscription?: IOrgSubscriptionResponseDTO
  callerID?: string
}

export interface ILegalEntityObj {
  id?: string
  addressLine1: string
  addressLine2: string
  businessName: string
  businessTaxId: number
  city: string
  firstName: string
  lastName: string
  postalCode: string
  state: string
  type: string
  connectURL?: string
}

export interface ICreateBankAccountObj {
  accountHolderType: string
  accountHolderName: string
  accountNumber: string
  isPrimary: boolean
  routingNumber: string
  country: string
  currency: string
  status: string // OK or FAILED according to UI
}

export interface IBankAccountObj {
  id: string
  bankName: string
  isPrimary: boolean
  lastFourNumbers: string
  orgId: string
  default_for_currency?: boolean
}

export interface IOrganization {
  id: string
  name: string
  services: IServiceObject[]
  description?: string
}

export interface IOrganizationsMetadata {
  fetching: boolean
  fetchingError: string
  fetchingSuccess: string
  processing: boolean
  processingError: string
  processingSuccess: string
}

export interface IOrgCreateObj {
  name: string
  logo: string
  email: string
  state: string
  phone: string
  timeZone: number // TODO fixed me
  timeFormat: string
  website: string
  description?: string
  callerID?: string
}

export type StateOrganizationMap = IMap<IOrgObj>

export interface IRemovedOrganizationBankAccountResponseDTO {
  id: string
  object: string
  currency: string
  deleted: boolean
}



// WEBPACK FOOTER //
// ./src/types/organization.ts